import { defineRouterLink, defineRouterLinkTarget, defineRouterView } from '@seamless/router';

export function initRouter() {
  defineRouterLink();
  defineRouterLinkTarget();
  defineRouterView();
}
